// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages-container {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.5rem;
  min-height: 0;
  max-height: 100%;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: rgba(209, 213, 219, 0.7) transparent;
}

.messages-container::-webkit-scrollbar {
  width: 8px;
}

.messages-container::-webkit-scrollbar-track {
  background: transparent;
}

.messages-container::-webkit-scrollbar-thumb {
  background-color: rgba(209, 213, 219, 0.8);
  border-radius: 10px;
}

.dark .messages-container {
  scrollbar-color: rgba(75, 85, 99, 0.7) transparent;
}

.dark .messages-container::-webkit-scrollbar-thumb {
  background-color: rgba(75, 85, 99, 0.9);
}

.message {
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  margin-bottom: 1.05rem;
  animation: fadeIn 0.3s ease-in;
}

.message.client {
  justify-content: flex-start;
}

.message.counsellor {
  justify-content: flex-end;
}

.message-bubble-shell {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  width: auto;
  max-width: 70%;
}

.message-bubble-shell--thinking-llm-counsellor {
  transform: translateY(0.75rem);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-text {
  background: #f3f4f6;
  padding: 0.72rem 0.95rem;
  border-radius: 15px;
  line-height: 1.5;
  color: #1f2937;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: normal;
  transition: all 0.3s ease;
  max-width: 70%;
}

.message-bubble-shell > .message-text,
.message-bubble-shell > .message-text--markdown {
  max-width: none;
}

.dark .message-text {
  background: #374151;
  color: #f9fafb;
}

.message-text.message-text--user {
  background: #e5e7eb;
  color: #1f2937;
}

.dark .message-text.message-text--user {
  background: #4b5563;
  color: #f9fafb;
}

.message-text--markdown > *:first-child,
.message-text-plain--markdown > *:first-child {
  margin-top: 0;
}

.message-text--markdown > *:last-child,
.message-text-plain--markdown > *:last-child {
  margin-bottom: 0;
}

.message-text--markdown p,
.message-text-plain--markdown p {
  margin: 0 0 0.75rem;
}

.message-text--markdown ul,
.message-text--markdown ol,
.message-text-plain--markdown ul,
.message-text-plain--markdown ol {
  margin: 0 0 0.75rem;
  padding-left: 1.25rem;
}

.message-text--markdown li,
.message-text-plain--markdown li {
  margin: 0.2rem 0;
}

.message-text--markdown code,
.message-text-plain--markdown code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace;
  font-size: 0.95em;
}

.message-text-plain {
  padding: 0.08rem 0;
  line-height: 1.5;
  color: #1f2937;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-break: normal;
  transition: color 0.3s ease;
  max-width: 100%;
  width: 100%;
}

.message-bubble-shell > .message-text-plain,
.message-bubble-shell > .message-text-plain--markdown {
  width: auto;
}

.message-avatar {
  flex: 0 0 auto;
  margin-top: 0.7rem;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  background: #ffffff;
  pointer-events: none;
}

.message-avatar--robot {
  transform: translateY(-0.7rem);
}

.message-avatar--human {
  transform: translateY(0.12rem);
}

.message-avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.message-text-plain--markdown {
  width: fit-content;
  max-width: 75%;
}

.dark .message-text-plain {
  color: #f9fafb;
}

.btc-consent-inline-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.05rem auto 1.2rem;
}

.btc-consent-inline-actions {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  justify-content: center;
}

@media (max-width: 900px) {
  .btc-consent-inline-actions .consent-btn {
    flex: 1 1;
  }
}

.typing-indicator {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f7f7f8;
  border-radius: 8px;
  width: fit-content;
  transition: background-color 0.3s ease;
}

.dark .typing-indicator {
  background-color: #374151;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  background-color: #95a5a6;
  border-radius: 50%;
  animation: typing 1.4s infinite;
}

.dark .typing-indicator span {
  background-color: #9ca3af;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

.message-text-plain.streaming::after,
.message-text.streaming::after,
.message-text-plain--markdown.streaming::after,
.message-text--markdown.streaming::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: blinkCursor 1s step-end infinite;
  color: #6b7280;
  font-weight: 500;
}

.dark .message-text-plain.streaming::after,
.dark .message-text.streaming::after,
.dark .message-text-plain--markdown.streaming::after,
.dark .message-text--markdown.streaming::after {
  color: #9ca3af;
}

@keyframes blinkCursor {
  50% {
    opacity: 0;
  }
}

.message.message-faded {
  opacity: 0.4;
  transition: opacity 0.2s ease;
}

.message.message-faded:hover {
  opacity: 0.65;
}

/* Volley hovered in the TS3 traversal tree */
.message.message-highlighted {
  opacity: 1;
}

.message-highlighted .message-bubble-shell {
  border-radius: 18px;
  background: rgba(236, 254, 255, 0.6);
  box-shadow:
    0 0 0 3px rgba(8, 145, 178, 0.28),
    0 0 16px rgba(8, 145, 178, 0.18);
  transition: box-shadow 0.15s ease, background 0.15s ease;
}

.dark .message-highlighted .message-bubble-shell {
  background: rgba(18, 74, 69, 0.32);
  box-shadow:
    0 0 0 3px rgba(45, 212, 191, 0.28),
    0 0 16px rgba(45, 212, 191, 0.14);
}

@media (max-width: 768px) {
  .messages-container {
    padding: 1rem;
  }

  .message-text,
  .message-text-plain,
  .message-bubble-shell {
    max-width: 88%;
    font-size: 0.92rem;
  }
}

.App.App--single-column .message {
  gap: 0;
}

.App.App--single-column .message-avatar {
  display: none;
}

.App.App--single-column .messages-container {
  padding-top: 3.5rem;
}

.App.App--single-column .message-text,
.App.App--single-column .message-text-plain,
.App.App--single-column .message-bubble-shell {
  max-width: 94%;
}

.App.App--single-column .message-bubble-shell {
  flex: 0 1 94%;
}

.App.App--single-column .message.counsellor .message-bubble-shell {
  align-items: flex-end;
}

.App.App--single-column .message.client .message-bubble-shell {
  align-items: flex-start;
}

.App.App--single-column .message-text,
.App.App--single-column .message-text-plain {
  width: fit-content;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatMessageList.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,8FAA8F;EAC9F,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,SAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;;;EAIE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,2CAA2C;EAC3C,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC;;oCAEkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;EAClC;;qCAEmC;AACrC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".messages-container {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 1.5rem;\n  min-height: 0;\n  max-height: 100%;\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(209, 213, 219, 0.7) transparent;\n}\n\n.messages-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.messages-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.messages-container::-webkit-scrollbar-thumb {\n  background-color: rgba(209, 213, 219, 0.8);\n  border-radius: 10px;\n}\n\n.dark .messages-container {\n  scrollbar-color: rgba(75, 85, 99, 0.7) transparent;\n}\n\n.dark .messages-container::-webkit-scrollbar-thumb {\n  background-color: rgba(75, 85, 99, 0.9);\n}\n\n.message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  margin-bottom: 1.05rem;\n  animation: fadeIn 0.3s ease-in;\n}\n\n.message.client {\n  justify-content: flex-start;\n}\n\n.message.counsellor {\n  justify-content: flex-end;\n}\n\n.message-bubble-shell {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  width: auto;\n  max-width: 70%;\n}\n\n.message-bubble-shell--thinking-llm-counsellor {\n  transform: translateY(0.75rem);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message-text {\n  background: #f3f4f6;\n  padding: 0.72rem 0.95rem;\n  border-radius: 15px;\n  line-height: 1.5;\n  color: #1f2937;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: normal;\n  transition: all 0.3s ease;\n  max-width: 70%;\n}\n\n.message-bubble-shell > .message-text,\n.message-bubble-shell > .message-text--markdown {\n  max-width: none;\n}\n\n.dark .message-text {\n  background: #374151;\n  color: #f9fafb;\n}\n\n.message-text.message-text--user {\n  background: #e5e7eb;\n  color: #1f2937;\n}\n\n.dark .message-text.message-text--user {\n  background: #4b5563;\n  color: #f9fafb;\n}\n\n.message-text--markdown > *:first-child,\n.message-text-plain--markdown > *:first-child {\n  margin-top: 0;\n}\n\n.message-text--markdown > *:last-child,\n.message-text-plain--markdown > *:last-child {\n  margin-bottom: 0;\n}\n\n.message-text--markdown p,\n.message-text-plain--markdown p {\n  margin: 0 0 0.75rem;\n}\n\n.message-text--markdown ul,\n.message-text--markdown ol,\n.message-text-plain--markdown ul,\n.message-text-plain--markdown ol {\n  margin: 0 0 0.75rem;\n  padding-left: 1.25rem;\n}\n\n.message-text--markdown li,\n.message-text-plain--markdown li {\n  margin: 0.2rem 0;\n}\n\n.message-text--markdown code,\n.message-text-plain--markdown code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, monospace;\n  font-size: 0.95em;\n}\n\n.message-text-plain {\n  padding: 0.08rem 0;\n  line-height: 1.5;\n  color: #1f2937;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n  word-break: normal;\n  transition: color 0.3s ease;\n  max-width: 100%;\n  width: 100%;\n}\n\n.message-bubble-shell > .message-text-plain,\n.message-bubble-shell > .message-text-plain--markdown {\n  width: auto;\n}\n\n.message-avatar {\n  flex: 0 0 auto;\n  margin-top: 0.7rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  background: #ffffff;\n  pointer-events: none;\n}\n\n.message-avatar--robot {\n  transform: translateY(-0.7rem);\n}\n\n.message-avatar--human {\n  transform: translateY(0.12rem);\n}\n\n.message-avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.message-text-plain--markdown {\n  width: fit-content;\n  max-width: 75%;\n}\n\n.dark .message-text-plain {\n  color: #f9fafb;\n}\n\n.btc-consent-inline-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0.05rem auto 1.2rem;\n}\n\n.btc-consent-inline-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  justify-content: center;\n}\n\n@media (max-width: 900px) {\n  .btc-consent-inline-actions .consent-btn {\n    flex: 1 1 0;\n  }\n}\n\n.typing-indicator {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background-color: #f7f7f8;\n  border-radius: 8px;\n  width: fit-content;\n  transition: background-color 0.3s ease;\n}\n\n.dark .typing-indicator {\n  background-color: #374151;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  background-color: #95a5a6;\n  border-radius: 50%;\n  animation: typing 1.4s infinite;\n}\n\n.dark .typing-indicator span {\n  background-color: #9ca3af;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing {\n  0%, 60%, 100% {\n    transform: translateY(0);\n  }\n  30% {\n    transform: translateY(-10px);\n  }\n}\n\n.message-text-plain.streaming::after,\n.message-text.streaming::after,\n.message-text-plain--markdown.streaming::after,\n.message-text--markdown.streaming::after {\n  content: '|';\n  display: inline-block;\n  margin-left: 2px;\n  animation: blinkCursor 1s step-end infinite;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.dark .message-text-plain.streaming::after,\n.dark .message-text.streaming::after,\n.dark .message-text-plain--markdown.streaming::after,\n.dark .message-text--markdown.streaming::after {\n  color: #9ca3af;\n}\n\n@keyframes blinkCursor {\n  50% {\n    opacity: 0;\n  }\n}\n\n.message.message-faded {\n  opacity: 0.4;\n  transition: opacity 0.2s ease;\n}\n\n.message.message-faded:hover {\n  opacity: 0.65;\n}\n\n/* Volley hovered in the TS3 traversal tree */\n.message.message-highlighted {\n  opacity: 1;\n}\n\n.message-highlighted .message-bubble-shell {\n  border-radius: 18px;\n  background: rgba(236, 254, 255, 0.6);\n  box-shadow:\n    0 0 0 3px rgba(8, 145, 178, 0.28),\n    0 0 16px rgba(8, 145, 178, 0.18);\n  transition: box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.dark .message-highlighted .message-bubble-shell {\n  background: rgba(18, 74, 69, 0.32);\n  box-shadow:\n    0 0 0 3px rgba(45, 212, 191, 0.28),\n    0 0 16px rgba(45, 212, 191, 0.14);\n}\n\n@media (max-width: 768px) {\n  .messages-container {\n    padding: 1rem;\n  }\n\n  .message-text,\n  .message-text-plain,\n  .message-bubble-shell {\n    max-width: 88%;\n    font-size: 0.92rem;\n  }\n}\n\n.App.App--single-column .message {\n  gap: 0;\n}\n\n.App.App--single-column .message-avatar {\n  display: none;\n}\n\n.App.App--single-column .messages-container {\n  padding-top: 3.5rem;\n}\n\n.App.App--single-column .message-text,\n.App.App--single-column .message-text-plain,\n.App.App--single-column .message-bubble-shell {\n  max-width: 94%;\n}\n\n.App.App--single-column .message-bubble-shell {\n  flex: 0 1 94%;\n}\n\n.App.App--single-column .message.counsellor .message-bubble-shell {\n  align-items: flex-end;\n}\n\n.App.App--single-column .message.client .message-bubble-shell {\n  align-items: flex-start;\n}\n\n.App.App--single-column .message-text,\n.App.App--single-column .message-text-plain {\n  width: fit-content;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
